
import React from 'react';

// Mui
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';

// Componente para seleccionar el tema
// https://m2.material.io/inline-tools/color/

export const SelectTheme = ({ setValue, mode }) => {

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-end',
                justifyContent: 'flex-end',
                borderRadius: 1,
                fontFamily: 'Roboto'
            }}
        >
            <FormControl
                sx={{
                    display: "flex",
                    justifyContent: "end",
                    alignItems: 'center'
                }}
            >
                <RadioGroup
                    name="theme-toggle"
                    row={window.innerWidth > 1024}
                    value={mode}
                    onChange={(event) => {
                        setValue(event.target.value);
                        localStorage.setItem('theme', event.target.value)
                    }}
                >
                    <FormControlLabel value="light" control={<Radio />} sx={{ mr: '0.5vw !important' }} label="Claro" />
                    <FormControlLabel value="dark" control={<Radio />} sx={{ mr: '0.5vw !important' }} label="Oscuro" />
                </RadioGroup>
            </FormControl>
        </Box>
    );
};